export type DealAnalytics = {
    totalDeals: number;
    totalActiveDeals: number;
    createdLast24h: number;
    createdLast7d: number;
    dealsByDatabase: {
        [key: string]: number;
    };
    dealsOverTime: {
        [key: number]: number;
    };
    dealsByUser: {
        [key: string]: number;
    };
};

export type ExtractionAnalytics = {
    totalExtractions: number;
    extractionsLast24h: number;
    extractionsLast7d: number;
    extractionsByStatus: {
        [key: string]: number;
    };
    extractionsByUser: {
        [key: string]: number;
    };
    extractionsByFile: {
        [key: string]: number;
    };
    extractionsOverTime: {
        [key: number]: number;
    };
};

export type FileUploadAnalytics = {
    totalFilesUploaded: number;
    filesUploadedLast24h: number;
    filesUploadedLast7d: number;
    filesWithVirusDetails: number;
    filesDeleted: number;
    filesByUser: {
        [key: string]: number;
    };
    filesByFileType: {
        [key: string]: number;
    };
    filesUploadedOverTime: {
        [key: string]: number;
    };
};

export type UserAnalytics = {
    totalUsers: number;
    activeUsers: number;
    newUsersLast24h: number;
    newUsersLast7d: number;
    usersByType: {
        [key: string]: number;
    };
    disabledUsers: number;
    usersWithAuditAccess: number;
    usersWithOdinAccess: number;
    signupsOverTime: {
        [key: string]: number;
    };
};

export type MappingAnalytics = {
    mappingsCount: number;
    alteredMappings: number;
    accuracyPercentage: number;
    misclassifiedAccountTypePairs: Array<{
        [key: string]: string;
    }>;
    mostInaccurateSources: {
        [key: string]: number;
    };
    mostInaccurateTargets: {
        [key: string]: number;
    };
    accuracyByCoa: {
        [key: string]: number;
    };
};

export type UserPreferenceDashboardRow = {
    userId: number;
    userEmail: string;
    companyName: string;
    userSelectedDatabases?: number[] | null;
    model?: string | null;
    exportFormat?: string | null;
    exportProdaIncludeMappings?: boolean | null;
    exportProdaIncludeSummary?: boolean | null;
    exportProdaIncludeDetailedSummary?: boolean | null;
    exportIncludeNonOperating?: boolean | null;
    userRegion?: string | null;
    isRentRollUploadEnabled: boolean;
    useModelForParsing: boolean;
    useDocumentEngine: boolean;
    modifiedAt?: string | null;
};

export type DocEngineRequestDashboardRow = {
    extractionId: number;
    requestedAt: string;
    success: boolean;
    failureReason: string | null;
    validationChecks: Record<string, unknown>[];
    userId: number;
    userEmail: string;
    companyName: string;
    databaseId: number;
    projectId: number | null;
    originalFilename: string;
};

export type DashboardAnalytics = {
    dealAnalytics?: DealAnalytics | null;
    extractionAnalytics?: ExtractionAnalytics | null;
    fileUploadAnalytics?: FileUploadAnalytics | null;
    userAnalytics?: UserAnalytics | null;
    mappingAnalytics?: MappingAnalytics | null;
    userPreferences?: UserPreferenceDashboardRow[] | null;
    docEngineRequests?: DocEngineRequestDashboardRow[] | null;
};

export const CHART_COLORS = [
    "#8884d8",
    "#82ca9d",
    "#ffc658",
    "#8dd1e1",
    "#a4de6c",
    "#d0ed57",
    "#ff8042",
    "#d28d8d",
    "#cab1de",
    "#7fc97f",
];

export type TDashboardFilter = "internal" | "external" | "all";
